import { useTranslation } from "react-i18next";
import CompareStripedRows from "./CompareStripedRows";
import { V1Clinic } from "../../types/v1_schemas";

function TelehealthTable({
  providerA,
  providerB,
}: {
  providerA: V1Clinic;
  providerB: V1Clinic;
}) {
  const { t } = useTranslation();

  const rowData = [
    {
      label: t("available"),
      compareA: providerA.clinicTelehealthOption && providerA.clinicTelehealthOption!.lineageText !== "No Telehealth Available" ? true : false,
      compareB: providerB.clinicTelehealthOption && providerB.clinicTelehealthOption!.lineageText !== "No Telehealth Available" ? true : false
    },
  ];

  return <CompareStripedRows rows={rowData} title={t("telehealth")} />;
}

export default TelehealthTable;
